import { LoggedUser } from "../models/Person";
import { Post } from "../pages/DashBoard/partials/Feed/types/types";

interface NewPostDataProps {
  user: LoggedUser;
  heading: string;
  content: string;
  documentFile?: File;
  imageFiles?: File[];
  send_sms_notification?: boolean;
  publish_at?: string;
}

export const createNewPostData = ({user, heading, content, documentFile, imageFiles, send_sms_notification, publish_at}: NewPostDataProps) => {
  const postFormData = new FormData();
  const isLastNameEmpty = user.last_name == undefined || user.last_name == null;
  let userName = user.name;
  if (!isLastNameEmpty) {
    userName = `${user.name} ${user.last_name}`
  }
  const newPost: Post = {
    heading,
    content,
    user_id: user.id,
    user_name: userName,
    avatar_url: user.avatar_url,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    likes: JSON.stringify([]),
    comments: JSON.stringify([])
  };

  Object.entries(newPost).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    postFormData.append(key, value.toString());
  });

  // Add SMS notification flag
  if (send_sms_notification) {
    postFormData.append('send_sms_notification', 'true');
  }

  if (publish_at) {
    postFormData.append('publish_at', publish_at);
  }

  if (documentFile) {
    postFormData.append('document', documentFile);
  }

  if (imageFiles?.length) {
    imageFiles.forEach((file) => {
      postFormData.append(`images`, file);
    });
  }

  return postFormData;
}